import { useEffect, useState } from 'react'
import styles from './EditEstablishmentCardPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import IconTrashRed from '../../assets/icons/IconTrashRed.svg'
import EditPlatformCardShortInformation from '../../components/EditPlatformCardShortInformation/EditPlatformCardShortInformation'
import UploadPhotoComponent from '../../components/UploadPhotoComponent/UploadPhotoComponent'
import exit from '../../assets/icons/trash.svg'
import { UploadImagesType } from '../../types'
import CustomModal from '../../components/UI/CustomModal/CustomModal'
import DeleteComponent from '../../components/DeleteComponent/DeleteComponent'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import { changePlaceDescription, deleteCurrentPlaces } from '../../redux/actions/placesAction'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import PATH from '../../navigation/path'
import s from '../../styles/common/Form.module.css'
import {
  changeEstablishmentDescription,
  deleteCurrentEstablishment,
  deleteCurrentFileFromEstablishment,
  getCurrentEstablishment,
  pushNewFilesToEstablishment,
} from '../../redux/actions/establishmentsAction'
import TitleBlockForEditPages from '../../components/TitleBlockForEditPages/TitleBlockForEditPages'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import EventsList from '../../components/EventsList/EventsList'
import { PlaceEstablishment } from '../../redux/actions/types'
import { placesPerPage } from '../../constants/constants'
import { useMediaQuery } from 'react-responsive'
import { useToast } from '../../context/ToastContext'

const EditEstablishmentCardPage = () => {
  const [photos, setPhotos] = useState<UploadImagesType[]>([])
  const [photosFile, setPhotosFile] = useState<any[]>([])

  const [logo, setLogo] = useState<UploadImagesType[]>([])
  const [logoFile, setLogoFile] = useState<any[]>([])
  const [visible, setVisible] = useState<boolean>(false)
  const location = useLocation()
  const [navItem, setNavItem] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const { showSuccess, showError } = useToast()

  let { currentEstablishment, errorImage } = useAppSelector((state) => state.establishments)

  const { token } = useAppSelector((state) => state.auth)

  const { establishmentId } = useParams<{ establishmentId: string }>()

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const onDeleteEstablishment = async () => {
    const resultAction = await dispatch(
      deleteCurrentEstablishment({ establishmentId: establishmentId, token }),
    )

    if (deleteCurrentPlaces.rejected.match(resultAction)) {
      showError('Ошибка при удалении площадки')
    } else {
      navigate(-2)
      showSuccess('Площадка успешно удалена')
    }
  }

  const handleDeleteImage = (e: any) => {
    const targetIndex = e.target.dataset.imgindex * 1
    setPhotos([...photos.slice(0, targetIndex), ...photos.slice(targetIndex + 1)])
  }

  useEffect(() => {
    dispatch(getCurrentEstablishment({ establishmentId: establishmentId, token }))
  }, [establishmentId, dispatch])

  const onDeletePlatformHandler = () => {
    setVisible(true)
  }

  const onDeleteImageFromServer = async (image: string) => {
    const resultAction = await dispatch(
      deleteCurrentFileFromEstablishment({
        token,
        establishmentId: String(currentEstablishment.id),
        filesToDelete: [image],
      }),
    )

    if (deleteCurrentFileFromEstablishment.rejected.match(resultAction)) {
      showError('Ошибка при удалении файлов')
    } else {
      showSuccess('Файлы успешно удалены')
      await dispatch(
        getCurrentEstablishment({ establishmentId: String(currentEstablishment.id), token }),
      )
    }
  }

  const onUploadNewImages = async () => {
    const formData = new FormData()

    if (photosFile.length > 10) {
      showError('Вы можете загрузить максимум 10 картинок')

      return
    }

    if (photosFile.length !== 0) {
      for (let i = 0; i < photosFile.length; i++) {
        formData.append('images', photosFile[i])
      }

      const resultAction = await dispatch(
        pushNewFilesToEstablishment({
          establishmentId: String(currentEstablishment.id),
          formData,
          token,
        }),
      )

      if (pushNewFilesToEstablishment.rejected.match(resultAction)) {
        showError('Ошибка при добавлении файлов')
      } else {
        showSuccess('Файлы успешно добавлены')
        setPhotosFile([])
        setPhotos([])
        await dispatch(getCurrentEstablishment({ establishmentId: establishmentId, token }))
      }
    }
  }

  const onUploadNewLogo = async () => {
    const formData = new FormData()

    if (logoFile.length !== 0) {
      for (let i = 0; i < logoFile.length; i++) {
        formData.append('logo', logoFile[i])
      }

      const resultAction = await dispatch(
        pushNewFilesToEstablishment({
          establishmentId: String(currentEstablishment.id),
          formData,
          token,
        }),
      )

      if (pushNewFilesToEstablishment.rejected.match(resultAction)) {
        showError('Ошибка при добавлении лого')
      } else {
        showSuccess('Лого успешно добавлено')
        setLogoFile([])
        setLogo([])
        await dispatch(getCurrentEstablishment({ establishmentId: establishmentId, token }))
      }
    }
  }

  return (
    <div className={styles.editPlatformCard}>
      <CustomModal visible={visible} setVisible={setVisible}>
        <DeleteComponent
          title='Удаление площадки'
          description='Хотите удалить данную площадку ?'
          onCancelHandler={() => setVisible(false)}
          onDeleteHandler={onDeleteEstablishment}
        />
      </CustomModal>
      <Navbar />

      <div className={styles.imageContainer}>
        <HeaderForCard
          deleteButton={
            <CustomButton
              iconSrc={IconTrashRed}
              className={styles.deleteBtn}
              title={isMobile ? '' : 'Удалить площадку'}
              onClick={onDeletePlatformHandler}
            />
          }
          title={currentEstablishment.name}
        />
      </div>
      <div className={styles.navContainer}>
        <div
          onClick={() => setNavItem(1)}
          className={navItem === 1 ? `${styles.active} ${styles.navItem}` : styles.navItem}
        >
          Основная информация
        </div>
        <div
          onClick={() => setNavItem(2)}
          className={navItem === 2 ? `${styles.active} ${styles.navItem}` : styles.navItem}
        >
          Залы площадки
        </div>
      </div>
      <div className={styles.container}>
        <div style={navItem === 2 ? { maxWidth: '100%' } : {}} className={styles.content}>
          {navItem === 1 && (
            <>
              <div className={styles.imageWrapper}>
                <TitleBlockForEditPages
                  title={'Изображения'}
                  disabled={false}
                  handleSubmit={onUploadNewImages}
                />
                <div className={styles.imageUpload}>
                  <UploadPhotoComponent
                    editMode
                    photos={photos}
                    photosFile={photosFile}
                    setPhotos={setPhotos}
                    widthOneImageContainer={245}
                    widthOneGapOfImageContainer={20}
                    setPhotosFiles={setPhotosFile}
                  >
                    <div className={styles.imagesWrapper}>
                      {currentEstablishment.images.length > 0 &&
                        currentEstablishment.images.map((image, index) => {
                          return (
                            <div
                              className={styles.imagesContainer}
                              key={index}
                              data-imgindex={index + 100}
                            >
                              <div className={styles.imageExitContainer}>
                                <img
                                  className={styles.imageExit}
                                  src={exit}
                                  alt='exit'
                                  onClick={() => onDeleteImageFromServer(image)}
                                  data-imgindex={index}
                                />
                              </div>
                              <img
                                className={styles.image}
                                src={`${process.env.REACT_APP_BASE_URL_IMAGES}${image}`}
                                alt={image}
                              />
                            </div>
                          )
                        })}
                      {photos.length > 0 &&
                        photos.map((photo, index) => {
                          return (
                            <div
                              className={styles.imagesContainer}
                              key={index}
                              data-imgindex={index}
                            >
                              <div className={styles.imageExitContainer}>
                                <img
                                  className={styles.imageExit}
                                  src={exit}
                                  alt='exit'
                                  onClick={handleDeleteImage}
                                  data-imgindex={index}
                                />
                              </div>
                              <img className={styles.image} src={photo?.src} alt={photo.name} />
                            </div>
                          )
                        })}
                    </div>
                  </UploadPhotoComponent>
                  <>
                    {errorImage && (
                      <p className={`${s.errorValidation} ${s.networkError}`}>{errorImage}</p>
                    )}
                  </>
                </div>
              </div>
              <EditPlatformCardShortInformation
                platformData={currentEstablishment}
                forEstablishments
              />
              <div className={styles.imageWrapper}>
                <TitleBlockForEditPages
                  title={'Логотип'}
                  disabled={false}
                  handleSubmit={onUploadNewLogo}
                />
                <div className={styles.imageUpload}>
                  <UploadPhotoComponent
                    htmlFor='logo'
                    editMode
                    photos={logo}
                    photosFile={logoFile}
                    setPhotos={setLogo}
                    widthOneImageContainer={245}
                    widthOneGapOfImageContainer={20}
                    setPhotosFiles={setLogoFile}
                    hideInputIfHasValue={true}
                    currentValue={currentEstablishment.logo}
                    hasLocalFiles={logo.length > 0 || logoFile.length > 0}
                  >
                    {currentEstablishment?.logo && (
                      <div className={styles.imagesContainer}>
                        <div className={styles.imageExitContainer}>
                          <img
                            className={styles.imageExit}
                            src={exit}
                            alt='exit'
                            onClick={() => onDeleteImageFromServer(currentEstablishment.logo!)}
                          />
                        </div>
                        <img
                          className={styles.image}
                          src={`${process.env.REACT_APP_BASE_URL_IMAGES}${currentEstablishment?.logo}`}
                          alt={currentEstablishment?.logo}
                        />
                      </div>
                    )}
                    {logo.map((photo, index) => (
                      <div className={styles.imagesContainer} key={index} data-imgindex={index}>
                        <div className={styles.imageExitContainer}>
                          <img
                            className={styles.imageExit}
                            src={exit}
                            alt='exit'
                            onClick={handleDeleteImage}
                            data-imgindex={index}
                          />
                        </div>
                        <img className={styles.image} src={photo?.src} alt={photo.name} />
                      </div>
                    ))}
                  </UploadPhotoComponent>
                  <>
                    {errorImage && (
                      <p className={`${s.errorValidation} ${s.networkError}`}>{errorImage}</p>
                    )}
                  </>
                </div>
              </div>
            </>
          )}
          {navItem === 2 && (
            <>
              <div className={styles.placesContainer}>
                {Array.isArray(currentEstablishment.places) &&
                currentEstablishment.places.length > 0 ? (
                  <EventsList
                    eventList={currentEstablishment.places.map((place: PlaceEstablishment) => ({
                      id: place.id,
                      title: place.name,
                      subTitle: place.city,
                      numberOfPerson: place.size.toString(),
                      images: Array.isArray(place.images)
                        ? place.images.map((img: string, index: number) => ({
                            id: index,
                            src: img,
                          }))
                        : [],
                    }))}
                    pageSize={placesPerPage}
                    bookingData={location?.state ? location.state : null}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalCountPages={currentEstablishment.places.length}
                  />
                ) : (
                  <div className={styles.center}>Список залов пуст...</div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default EditEstablishmentCardPage
